import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowLeft, Lock, ArrowRight } from "lucide-react";

export default function SubscribeGate() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-[#F2F2F2]" data-testid="subscribe-gate">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-5 md:px-8 py-16 md:py-24 flex items-center">
        <div className="w-full aq-card p-8 md:p-14 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#1E3A5F]/8 blur-3xl" aria-hidden />
          <div className="relative">
            <button
              onClick={() => navigate("/dashboard")}
              className="flex items-center gap-2 font-mono-aq text-[0.7rem] uppercase tracking-[0.2em] text-[#4A4A4A] hover:text-[#0A0A0A] mb-8"
              data-testid="gate-back"
            >
              <ArrowLeft size={14} /> {t.gate.back}
            </button>

            <div className="flex items-center gap-3 label-eyebrow mb-4">
              <Lock size={14} className="text-[#1E3A5F]" /> — {t.gate.subtitle}
            </div>
            <h1 className="font-serif-display text-4xl md:text-6xl tracking-tighter leading-[1.05]">
              {t.gate.title}
            </h1>
            <p className="mt-6 text-[#4A4A4A] text-lg max-w-2xl leading-relaxed">
              {t.gate.body}
            </p>

            <div className="mt-10 flex flex-wrap gap-3">
              <a href="/#pricing" className="aq-button-primary" data-testid="gate-pricing-cta">
                {t.gate.cta} <ArrowRight size={14} />
              </a>
              <button onClick={() => navigate("/dashboard")} className="aq-button-ghost" data-testid="gate-back-btn">
                {t.gate.back}
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
